// extracted by mini-css-extract-plugin
export default {"promo-container":"PromoBannerCustomCarousel_promo-container__VqvGb","promo-carousel-item-padding-10-px":"PromoBannerCustomCarousel_promo-carousel-item-padding-10-px__02Rxt"};